import React, { useState } from "react";

import Button, { ButtonTypes } from "../../../../components/Button";
import { ConfirmPopUp } from "../../../../components/PopUp";
import {
  EditorActions,
  EditorError,
  FixSection,
  FixSectionTitle,
} from "./styles";
import { AutomaticPricingSectionProps } from "./types";

export const AutomaticPricingSection: React.FC<
  AutomaticPricingSectionProps
> = ({ instrument: { symbol }, isSubmitting, error, onConfirm }) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const handleOpen = () => setIsConfirming(true);

  return (
    <FixSection aria-label="Automatic pricing">
      <FixSectionTitle>Automatic pricing</FixSectionTitle>
      {error && <EditorError role="alert">{error}</EditorError>}
      <EditorActions>
        <Button
          type={ButtonTypes.primary}
          isLoading={isSubmitting}
          onClick={handleOpen}
        >
          Use automatic pricing
        </Button>
      </EditorActions>
      <ConfirmPopUp
        isOpen={isConfirming}
        setIsOpen={setIsConfirming}
        title={`Use automatic pricing for ${symbol}?`}
        text={`${symbol} will receive provider prices again, and every holder will be revalued.`}
        confirmLabel="Use automatic pricing"
        onConfirm={onConfirm}
      />
    </FixSection>
  );
};
